import React from "react"
import "./frames.css"

const Mantenimiento = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Mantenimiento de Cámaras Perry</h1>
      <p className="frames-text">
        Desde 2015 nos encargamos de llevar a cabo todos los mantenimientos
        anuales de las cámaras Perry en España y Portugal, así como en gran
        parte de países de Europa. Ofrecemos un servicio de rápida respuesta y
        eficacia.
      </p>

      <h2 className="frames-subtitle">
        Programa Anual de Servicio De Mantenimiento Preventivo
      </h2>
      <p className="frames-text">
        Todas las cámaras de Perry deben ser revisadas anualmente para mantener
        la seguridad y eficiencia operativa. Nuestro programa anual de
        mantenimiento preventivo incluye inspecciones exhaustivas, calibraciones
        y actualizaciones necesarias para asegurar el máximo rendimiento del
        equipo.
      </p>
    </div>
  )
}

export default Mantenimiento
